import React, { Component } from "react";
import "./Modal.css";

//TODO: Return Image as props after clicking on done
class CustomModal extends Component {
    constructor(props) {
        super(props);
    }


    render() {
        return (
            <div className="dialog-box-container">
                <div className="helper-container"></div>
                <div className="dialog-box">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default CustomModal;
